import PublicDashboardViewer from './PublicDashboardViewer';

export default PublicDashboardViewer;
